/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  GET_ALL_SHIFTTYPE(state, shifttypes) {
    state.getAllShiftType = shifttypes;
  },
  ADD_ShiftType(state, payload) {
    state.getAllShiftType.push(payload);
    console.log(state.getAllShiftType);
  },
  UPDATE_ShiftType(state, items) {
    const index = state.getAllShiftType.findIndex(
      (e) => e.shiftTypeId === items.shiftTypeId
    );
    Object.assign(state.getAllShiftType[index], {
      shiftTypeCode: items.shiftTypeCode,
      shiftTypeName: items.shiftTypeName,
    });
  },
  GET_ALL_SCHEDULETYPE(state, scheduletypes) {
    state.getAllScheduleType = scheduletypes;
  },
  ADD_SCHEDULETYPE(state, payload) {
    state.getAllScheduleType.push(payload);
    console.log(state.getAllScheduleType);
  },
  UPDATE_ScheduleType(state, items) {
    const index = state.getAllScheduleType.findIndex(
      (e) => e.scheduleTypeId === items.scheduleTypeId
    );
    Object.assign(state.getAllScheduleType[index], {
      scheduleTypeCode: items.scheduleTypeCode,
      scheduleTypeName: items.scheduleTypeName,
      scheduleTypeId: items.scheduleTypeId,
    });
  },
  GET_ALL_SEGMENTTYPE(state, segmenttypes) {
    state.getAllSegmentType = segmenttypes;
  },
  ADD_SEGMENTTYPE(state, payload) {
    state.getAllSegmentType.push(payload);
    console.log(state.getAllSegmentType);
  },
  UPDATE_SegmentType(state, items) {
    const index = state.getAllSegmentType.findIndex(
      (e) => e.segmentTypeId === items.segmentTypeId
    );
    Object.assign(state.getAllSegmentType[index], {
      segmentTypeCode: items.segmentTypeCode,
      segmentTypeName: items.segmentTypeName,
      segmentTypeId: items.segmentTypeId,
    });
  },

  GET_ALL_LEAVETYPE(state, leaveType) {
    state.getAllLeaveTypes = leaveType;
  },

  ADD_LEAVETYPE(state, payload) {
    state.leaveType.push(payload);
    console.log(state.leaveType);
  },

  UPDATE_LeaveType(state, items) {
    const index = state.getAllLeaveTypes.findIndex(
      (e) => e.leaveTypeId === items.leaveTypeId
    );
    Object.assign(state.getAllLeaveTypes[index], {
      leaveTypeCode: items.leaveTypeCode,
      leaveTypeName: items.leaveTypeName,
      minDays: items.minDays,
      maxDays: items.maxDays,
      isBackDate: items.isBackDate,
      isAttachment: items.isAttachment,
      isRequiredReason: items.isRequiredReason,
      isAccrued: items.isAccrued,
      dayOfMonthAccrued: items.dayOfMonthAccrued,
      isForfeited: items.isForfeited,
      daysForForfeited: items.daysForForfeited,
      isCarryOver: items.isCarryOver,
      daysForCarryOver: items.daysForCarryOver,
      isReserved: items.isReserved,
      daysForReserved: items.daysForReserved,
      isConvertibleToCash: items.isConvertibleToCash,
      daysConvertibleToCash: items.daysConvertibleToCash,
      monthExpiredForfeited: items.monthExpiredForfeited,
      dayExpiredForfeited: items.dayExpiredForfeited,
      monthExpiredReserved: items.monthExpiredReserved,
      dayExpiredReserved: items.dayExpiredReserved,
      monthExpiredLeave: items.monthExpiredLeave,
      dayExpiredLeave: items.dayExpiredLeave,
      consecutiveDays: items.consecutiveDays,
      maxCountForAttachment: items.maxCountForAttachment,
      maxDaysforBackDate: items.maxDaysforBackDate,
      taxableInExcessOf: items.taxableInExcessOf,
      leaveAvailAfterHowManyMonths: items.leaveAvailAfterHowManyMonths,
      isIncludedIn13thMonth: items.isIncludedIn13thMonth,
      isIncludedInFinalPay: items.isIncludedInFinalPay,
      leaveTypeId: items.leaveTypeId,
    });
  },

  GET_ALL_CLAIMCATEGORY(state, claimsCategory) {
    state.claimsCategory = claimsCategory;
  },
  ADD_CLAIMCATEGORY(state, payload) {
    state.claimsCategory.push(payload);
    console.log(state.claimsCategory);
  },
  UPDATE_ClaimsCategory(state, items) {
    const index = state.claimsCategory.findIndex(
      (e) => e.claimsCategoryId === items.claimsCategoryId
    );
    Object.assign(state.claimsCategory[index], {
      claimsCategoryCode: items.claimsCategoryCode,
      claimsCategoryName: items.claimsCategoryName,
    });
  },
  GET_ALL_CLAIMSUBCATEGORY(state, claimsSubCategory) {
    state.claimsSubCategory = claimsSubCategory;
  },
  ADD_CLAIMSUBCATEGORY(state, payload) {
    state.claimsSubCategory.push(payload);
    console.log(state.claimsSubCategory);
  },
  UPDATE_ClaimsSubCategory(state, items) {
    const index = state.claimsSubCategory.findIndex(
      (e) => e.claimsSubCategoryId === items.claimsSubCategoryId
    );
    Object.assign(state.claimsSubCategory[index], {
      claimsSubCategoryCode: items.claimsSubCategoryCode,
      claimsSubCategoryName: items.claimsSubCategoryName,
      claimsCategoryId: items.claimsCategoryId,
    });
  },
  GET_ALL_LOANTYPE(state, loanType) {
    state.getAllLoanType = loanType;
  },
  ADD_LOANTYPE(state, payload) {
    state.getAllLoanType.push(payload);
    console.log(state.getAllLoanType);
  },
  UPDATE_LOANTYPE(state, items) {
    const index = state.getAllLoanType.findIndex(
      (e) => e.loanTypeId === items.loanTypeId
    );
    Object.assign(state.getAllLoanType[index], {
      loanTypeCode: items.loanTypeCode,
      loanTypeName: items.loanTypeName,
      loanTypeId: items.loanTypeId,
    });
  },
  GET_ALL_LOANNAME(state, loanName) {
    state.getAllLoanName = loanName;
  },
  ADD_LOANNAME(state, payload) {
    state.getAllLoanName.push(payload);
    console.log(state.getAllLoanName);
  },
  UPDATE_LOANNAME(state, items) {
    const index = state.getAllLoanName.findIndex(
      (e) => e.loanNameId === items.loanNameId
    );
    Object.assign(state.getAllLoanName[index], {
      loanNameCode: items.loanNameCode,
      loanNameName: items.loanNameName,
      loanNameId: items.loanNameId,
      loanTypeId: items.loanTypeId,
    });
  },
  GET_ALL_LOANCATEGORY(state, loanCategory) {
    state.loanCategory = loanCategory;
  },
  ADD_LoanCategory(state, payload) {
    state.loanCategory.push(payload);
    console.log(state.loanCategory);
  },
  UPDATE_loanCategory(state, items) {
    const index = state.loanCategory.findIndex(
      (e) => e.loanCategoryId === items.loanCategoryId
    );
    Object.assign(state.loanCategory[index], {
      loanCategoryCode: items.loanCategoryCode,
      loanCategoryName: items.loanCategoryName,
    });
  },

  GET_ALL_LOANSUBCATEGORY(state, loanSubCategory) {
    state.loanSubCategory = loanSubCategory;
  },
  ADD_LoanSubCategory(state, payload) {
    state.loanSubCategory.push(payload);
    console.log(state.loanSubCategory);
  },
  UPDATE_LoanSubCategory(state, items) {
    const index = state.loanSubCategory.findIndex(
      (e) => e.loanSubCategoryId === items.loanSubCategoryId
    );
    Object.assign(state.loanSubCategory[index], {
      loanSubCategoryCode: items.loanSubCategoryCode,
      loanSubCategoryName: items.loanSubCategoryName,
      loanCategoryId: items.loanCategoryId,
    });
  },
  DELETE_LoanSubCategory(state, id) {
    const index = state.loanSubCategory.findIndex(
      (e) => e.loanSubCategoryId === id
    );
    state.loanSubCategory.splice(index, 1);
  },
  GET_ALL_OVERTIMETYPE(state, overtimeTypes) {
    state.overtimeTypes = overtimeTypes;
  },
  ADD_OvertimeType(state, payload) {
    state.overtimeTypes.push(payload);
    console.log(state.overtimeTypes);
  },
  UPDATE_OvertimeType(state, items) {
    const index = state.overtimeTypes.findIndex(
      (e) => e.overtimeTypeId === items.overtimeTypeId
    );
    Object.assign(state.overtimeTypes[index], {
      overtimeTypeId: items.overtimeTypeId,
      overtimeTypeCode: items.overtimeTypeCode,
      overtimeTypeName: items.overtimeTypeName,
      otRate: items.otRate,
      nsdRate: items.nsdRate,
    });
  },
  UPLOAD_PHOTO(state, photo) {
    state.photoUpload.unshift(photo);
  },
  GET_ALL_Department(state, payload) {
    state.getAllDepartment = payload;
  },
  ADD_Department(state, payload) {
    state.getAllDepartment.push(payload);
    console.log(state.getAllDepartment);
  },
  UPDATE_Department(state, items) {
    const index = state.getAllDepartment.findIndex(
      (e) => e.departmentId === items.departmentId
    );
    Object.assign(state.getAllDepartment[index], {
      departmentCode: items.departmentCode,
      departmentName: items.departmentName,
      divisionId: items.divisionId,
    });
  },
  GET_ALL_Branch(state, payload) {
    state.getAllBranch = payload;
  },
  ADD_BRANCH(state, payload) {
    state.getAllBranch.push(payload);
    console.log(state.getAllBranch);
  },
  UPDATE_BRANCH(state, items) {
    const index = state.getAllBranch.findIndex(
      (e) => e.branchId === items.branchId
    );
    Object.assign(state.getAllBranch[index], {
      branchCode: items.branchCode,
      branchName: items.branchName,
    });
  },
  GET_ALL_Position(state, payload) {
    state.getAllPosition = payload;
  },
  ADD_POSITION(state, payload) {
    state.getAllPosition.push(payload);
    console.log(state.getAllPosition);
  },
  UPDATE_POSITION(state, items) {
    const index = state.getAllPosition.findIndex(
      (e) => e.positionId === items.positionId
    );
    Object.assign(state.getAllPosition[index], {
      positionCode: items.positionCode,
      positionName: items.positionName,
    });
  },
  GET_ALL_Division(state, payload) {
    state.getAllDivision = payload;
  },
  ADD_DIVISION(state, payload) {
    state.getAllDivision.push(payload);
    console.log(state.getAllDivision);
  },
  updateDivision(state, items) {
    const index = state.getAllDivision.findIndex(
      (e) => e.divisionId === items.divisionId
    );
    Object.assign(state.getAllDivision[index], {
      divisionCode: items.divisionCode,
      divisionName: items.divisionName,
    });
  },
  GET_ALL_Section(state, payload) {
    state.getAllSection = payload;
  },
  ADD_SECTION(state, payload) {
    state.getAllSection.push(payload);
    console.log(state.getAllSection);
  },
  updateSection(state, items) {
    const index = state.getAllSection.findIndex(
      (e) => e.sectionId === items.sectionId
    );
    Object.assign(state.getAllSection[index], {
      sectionCode: items.sectionCode,
      sectionName: items.sectionName,
    });
  },
  GET_ALL_EmployeeCategory(state, payload) {
    state.getAllEmployeeCategory = payload;
  },
  ADD_EMPLOYEECATEGORY(state, payload) {
    state.getAllEmployeeCategory.push(payload);
    console.log(state.getAllEmployeeCategory);
  },
  UPDATE_EMPLOYEECATEGORY(state, items) {
    const index = state.getAllEmployeeCategory.findIndex(
      (e) => e.employeeCategoryId === items.employeeCategoryId
    );
    Object.assign(state.getAllEmployeeCategory[index], {
      employeeCategoryCode: items.employeeCategoryCode,
      employeeCategoryName: items.employeeCategoryName,
    });
  },
  GET_ALL_EarningsType(state, payload) {
    state.getAllEarningsType = payload;
  },
  ADD_EarningsType(state, payload) {
    state.getAllEarningsType.push(payload);
  },
  UPDATE_EarningsType(state, items) {
    const index = state.getAllEarningsType.findIndex(
      (e) => e.earningsTypeId === items.earningsTypeId
    );
    Object.assign(state.getAllEarningsType[index], {
      earningsTypeCode: items.earningsTypeCode,
      earningsTypeName: items.earningsTypeName,
      earningsCategoryId: items.earningsCategoryId,
      isTaxable: items.isTaxable,
      isBonus: items.isBonus,
      isYTD: items.isYTD,
      addTo: items.addTo,
    });
  },
  DELETE_EarningsType(state, id) {
    const index = state.getAllEarningsType.findIndex(
      (e) => e.earningsTypeId === id
    );
    state.getAllEarningsType.splice(index, 1);
  },
  GET_ALL_EarningsCategory(state, payload) {
    state.getAllEarningsCategory = payload;
  },
  ADD_EARNINGSCATEGORY(state, payload) {
    state.getAllEarningsCategory.push(payload);
    console.log(state.getAllEarningsCategory);
  },
  UPDATE_EARNINGSCATEGORY(state, items) {
    const index = state.getAllEarningsCategory.findIndex(
      (e) => e.earningsCategoryId === items.earningsCategoryId
    );
    Object.assign(state.getAllEarningsCategory[index], {
      earningsCategoryCode: items.earningsCategoryCode,
      earningsCategoryName: items.earningsCategoryName,
    });
  },
  GET_ALL_DeductionsType(state, payload) {
    state.getAllDeductionsType = payload;
  },
  ADD_DeductionsType(state, payload) {
    state.getAllDeductionsType.push(payload);
    console.log(state.getAllDeductionsType);
  },
  UPDATE_DeductionsType(state, items) {
    const index = state.getAllDeductionsType.findIndex(
      (e) => e.deductionsTypeId === items.deductionsTypeId
    );
    Object.assign(state.getAllDeductionsType[index], {
      deductionsTypeCode: items.deductionsTypeCode,
      deductionsTypeName: items.deductionsTypeName,
      deductionsCategoryId: items.deductionsCategoryId,
      isTaxable: items.isTaxable,
      isBonus: items.isBonus,
      isYTD: items.isYTD,
      addTo: items.addTo,
    });
  },
  DELETE_DeductionsType(state, id) {
    const index = state.getAllDeductionsType.findIndex(
      (e) => e.DeductionsTypeId === id
    );
    state.getAllDeductionsType.splice(index, 1);
  },
  GET_ALL_DeductionsCategory(state, payload) {
    state.getAllDeductionsCategory = payload;
  },
  ADD_DEDUCTIONSCATEGORY(state, payload) {
    state.getAllDeductionsCategory.push(payload);
    console.log(state.getAllDeductionsCategory);
  },
  UPDATE_DEDUCTIONSCATEGORY(state, items) {
    const index = state.getAllDeductionsCategory.findIndex(
      (e) => e.deductionsTypeId === items.deductionsTypeId
    );
    Object.assign(state.getAllDeductionsCategory[index], {
      deductionsCategoryCode: items.deductionsCategoryCode,
      deductionsCategoryName: items.deductionsCategoryName,
      deductionsCategoryId: items.deductionsCategoryId,
    });
  },
  GET_ALL_CivilStatus(state, payload) {
    state.getAllCivilStatus = payload;
  },
  ADD_CIVILSTATUS(state, payload) {
    state.getAllCivilStatus.push(payload);
    console.log(state.getAllCivilStatus);
  },
  UPDATE_CIVILSTATUS(state, items) {
    const index = state.getAllCivilStatus.findIndex(
      (e) => e.civilStatusId === items.civilStatusId
    );
    Object.assign(state.getAllCivilStatus[index], {
      civilStatusCode: items.civilStatusCode,
      civilStatusName: items.civilStatusName,
      civilStatusId: items.civilStatusId,
    });
  },
  GET_ALL_Nationality(state, payload) {
    state.getAllNationality = payload;
  },
  ADD_NATIONALITY(state, payload) {
    state.getAllNationality.push(payload);
    console.log(state.getAllNationality);
  },
  UPDATE_NATIONALITY(state, items) {
    const index = state.getAllNationality.findIndex(
      (e) => e.nationalityId === items.nationalityId
    );
    Object.assign(state.getAllNationality[index], {
      nationalityCode: items.nationalityCode,
      nationalityName: items.nationalityName,
      nationalityId: items.nationalityId,
    });
  },
  GET_ALL_Religion(state, payload) {
    state.getAllReligion = payload;
  },
  ADD_RELIGION(state, payload) {
    state.getAllReligion.push(payload);
    console.log(state.getAllReligion);
  },
  UPDATE_RELIGION(state, items) {
    const index = state.getAllReligion.findIndex(
      (e) => e.religionId === items.religionId
    );
    Object.assign(state.getAllReligion[index], {
      religionCode: items.religionCode,
      religionName: items.religionName,
      religionId: items.religionId,
    });
  },
  GET_ALL_Relationship(state, payload) {
    state.getAllRelationshipLookup = payload;
  },
  ADD_RELATIONSHIPLOOKUP(state, payload) {
    state.getAllRelationshipLookup.push(payload);
    console.log(state.getAllRelationshipLookup);
  },
  UPDATE_RELATIONSHIPLOOKUP(state, items) {
    const index = state.getAllRelationshipLookup.findIndex(
      (e) => e.relationshipId === items.relationshipId
    );
    Object.assign(state.getAllRelationshipLookup[index], {
      relationshipCode: items.relationshipCode,
      relationshipName: items.relationshipName,
      relationshipId: items.relationshipId,
    });
  },
  GET_ALL_AccreditationType(state, payload) {
    state.getAllAccreditationType = payload;
  },
  ADD_ACCREDITATIONTYPE(state, payload) {
    state.getAllAccreditationType.push(payload);
    console.log(state.getAllAccreditationType);
  },
  UPDATE_ACCREDITATIONTYPE(state, items) {
    const index = state.getAllAccreditationType.findIndex(
      (e) => e.accreditationTypeId === items.accreditationTypeId
    );
    Object.assign(state.getAllAccreditationType[index], {
      accreditationTypeCode: items.accreditationTypeCode,
      accreditationTypeName: items.accreditationTypeName,
      accreditationTypeId: items.accreditationTypeId,
    });
  },
  GET_ALL_Rank(state, payload) {
    state.getAllRankLookup = payload;
  },
  ADD_RANK(state, payload) {
    state.getAllRankLookup.push(payload);
    console.log(state.getAllRankLookup);
  },
  UPDATE_RANK(state, items) {
    const index = state.getAllRankLookup.findIndex(
      (e) => e.rankId === items.rankId
    );
    Object.assign(state.getAllRankLookup[index], {
      rankCode: items.rankCode,
      rankName: items.rankName,
      rankId: items.rankId,
    });
  },
  GET_ALL_Association(state, payload) {
    state.getAllAssociationLookup = payload;
  },
  ADD_ASSOCIATION(state, payload) {
    state.getAllAssociationLookup.push(payload);
    console.log(state.getAllAssociationLookup);
  },
  UPDATE_ASSOCIATION(state, items) {
    const index = state.getAllAssociationLookup.findIndex(
      (e) => e.associationId === items.associationId
    );
    Object.assign(state.getAllAssociationLookup[index], {
      associationCode: items.associationCode,
      associationName: items.associationName,
      associationId: items.associationId,
    });
  },
  GET_ALL_Bank(state, payload) {
    state.getAllBankLookup = payload;
  },
  ADD_BANK(state, payload) {
    state.getAllBankLookup.push(payload);
    console.log(state.getAllBankLookup);
  },
  UPDATE_BANK(state, items) {
    const index = state.getAllBankLookup.findIndex(
      (e) => e.bankId === items.bankId
    );
    Object.assign(state.getAllBankLookup[index], {
      bankCode: items.bankCode,
      bankName: items.bankName,
      bankId: items.bankId,
    });
  },
  GET_ALL_Period(state, payload) {
    state.getAllPeriodLookup = payload;
  },
  GET_ALL_BenefitType(state, payload) {
    state.getAllBenefitTypeLookup = payload;
  },
  GET_ALL_LineOfBusiness(state, payload) {
    state.getAllLineOfBusinessLookup = payload;
  },
  GET_ALL_Degree(state, payload) {
    state.getAllDegreeLookup = payload;
  },
  GET_ALL_AreaOfStudy(state, payload) {
    state.getAllAreaOfStudyLookup = payload;
  },
  GET_ALL_Institution(state, payload) {
    state.getAllInstitutionLookup = payload;
  },
  GET_ALL_Award(state, payload) {
    state.getAllAwardLookup = payload;
  },
  GET_ALL_MarketSegment(state, payload) {
    state.getAllMarketSegmentLookup = payload;
  },
  GET_ALL_AppraisalType(state, payload) {
    state.getAllAppraisalTypeLookup = payload;
  },
  ADD_AppraisalType(state, payload) {
    state.getAllAppraisalTypeLookup.push(payload);
    console.log(state.getAllAppraisalTypeLookup);
  },
  UPDATE_AppraisalTypeLookup(state, items) {
    const index = state.getAllAppraisalTypeLookup.findIndex(
      (e) => e.appraisalTypeId === items.appraisalTypeId
    );
    Object.assign(state.getAllAppraisalTypeLookup[index], {
      appraisalTypeCode: items.appraisalTypeCode,
      appraisalTypeName: items.appraisalTypeName,
      appraisalTypeId: items.appraisalTypeId,
    });
  },

  GET_ALL_AppraisalRating(state, payload) {
    state.getAllAppraisalRatingLookup = payload;
  },

  ADD_AppraisalRating(state, payload) {
    state.getAllAppraisalRatingLookup.push(payload);
    console.log(state.getAllAppraisalRatingLookup);
  },
  UPDATE_AppraisalRating(state, items) {
    const index = state.getAllAppraisalRatingLookup.findIndex(
      (e) => e.appraisalRatingId === items.appraisalRatingId
    );
    Object.assign(state.getAllAppraisalRatingLookup[index], {
      appraisalRatingCode: items.appraisalRatingCode,
      appraisalRatingName: items.appraisalRatingName,
      appraisalRatingId: items.appraisalRatingId,
    });
  },
  GET_ALL_SalaryBasedOn(state, payload) {
    state.getAllSalaryBasedOnLookup = payload;
  },
  GET_ALL_ScheduleNumber(state, payload) {
    state.getAllScheduleNumber = payload;
  },
  GET_ALL_TaxReference(state, payload) {
    state.getAllTaxReferenceLookup = payload;
  },
  GET_ALL_PaymentMode(state, payload) {
    state.getAllPaymentModeLookup = payload;
  },
  UPDATE_PAYMENT(state, items) {
    const index = state.getAllPaymentModeLookup.findIndex(
      (e) => e.paymentModeId === items.paymentModeId
    );
    Object.assign(state.getAllPaymentModeLookup[index], {
      paymentModeCode: items.paymentModeCode,
      paymentModeName: items.paymentModeName,
      divisor: items.divisor,
      isUsed: items.isUsed,
    });
  },
  GET_ALL_Violation(state, payload) {
    state.getAllViolationLookup = payload;
  },
  GET_ALL_ViolationAction(state, payload) {
    state.getAllViolationActionLookup = payload;
  },
  GET_ALL_MedicalProcedure(state, payload) {
    state.getAllMedicalProcedureLookup = payload;
  },
  GET_ALL_Country(state, payload) {
    state.getAllCountryLookup = payload;
  },
  GET_ALL_CreatePayrollType(state, payload) {
    state.getAllCreatePayrollTypeLookup = payload;
  },
  ADD_CreatePayrollType(state, payload) {
    state.getAllCreatePayrollTypeLookup.push(payload);
    console.log(state.getAllCreatePayrollTypeLookup);
  },
  UPDATE_CreatePayrollType(state, items) {
    const index = state.getAllCreatePayrollTypeLookup.findIndex(
      (e) => e.createPayrollTypeId === items.createPayrollTypeId
    );
    Object.assign(state.getAllCreatePayrollTypeLookup[index], {
      createPayrollTypeCode: items.createPayrollTypeCode,
      createPayrollTypeName: items.createPayrollTypeName,
    });
  },
};
